import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  database: Yup.string().required('Please select a database')
});

export const initialValues = {
  database: ''
};
